import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const koBoToolbox = defineConnector({
  identifier: "koBoToolbox",
  name: "KoBoToolbox",
  tagLine: "Data collection",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://kf\\.kobotoolbox\\.org/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.token,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In your [KoBoToolbox account](https://kf.kobotoolbox.org/#/account-settings), find your API token in the account settings.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://kf.kobotoolbox.org/api/v2/assets/",
  },
});
